/// <reference path="../../../types.d.ts" />
import { FlexCard } from '@codametrix/ui-components';
import React, { useState } from 'react';
import JsonView from '@uiw/react-json-view';
import { nordTheme } from '@uiw/react-json-view/nord';
import { appServiceLines } from '@codametrix/ui-common';
import { ProcessSelection } from '@codametrix/shared-views';
import './case-json.scss';
import { sortCaseRuns } from '../../../reducers/cases.reducer';

const DISPLAY_ORDER = {
  ALPHA: 'alpha',
  ORIGINAL: 'original'
};

const CaseJson = (props: AppProps.CaseJsonView) => {
  const { caseDetail, activeCaseRun, onClick } = props;
  let activeCaseJson: CMxAPI.CaseRun | CMxAPI.CaseRunV2;
  if ('casejson' in activeCaseRun) {
    activeCaseJson = activeCaseRun.casejson;
  } else {
    activeCaseJson = activeCaseRun;
  }

  const [displayInfo, setDisplay] = useState({
    displayOrder: 'original',
    collapsed: true
  });

  const isAlphaSort = displayInfo.displayOrder === DISPLAY_ORDER.ALPHA;

  const handleToggleOrder = (event: React.MouseEvent) => {
    event.preventDefault();
    setDisplay({
      ...displayInfo,
      displayOrder:
        displayInfo.displayOrder === DISPLAY_ORDER.ALPHA
          ? DISPLAY_ORDER.ORIGINAL
          : DISPLAY_ORDER.ALPHA
    });
  };

  const handleToggleAll = (event: React.MouseEvent) => {
    event.preventDefault();
    setDisplay({
      ...displayInfo,
      collapsed: !displayInfo.collapsed
    });
  };

  let toDisplay = {};

  if (isAlphaSort) {
    const sortedKeys = Object.keys(activeCaseJson).sort();
    sortedKeys.forEach(key => {
      //@ts-ignore
      toDisplay[key] = activeCaseJson[key];
    });
  } else {
    toDisplay = activeCaseJson;
  }

  const sortedCaseRuns = sortCaseRuns(caseDetail, {});

  const json = (
    <JsonView
      value={toDisplay}
      displayObjectSize={false}
      collapsed={displayInfo.collapsed ? 3 : false}
      displayDataTypes={false}
      style={nordTheme}
    />
  );

  let accessionNumber = '';
  let accessionIssuer = '';
  if (
    'hospital_account_record' in activeCaseJson &&
    appServiceLines.isIPC(activeCaseJson.service_line)
  ) {
    accessionNumber =
      //@ts-ignore
      'Hospital Account Record: ' + activeCaseJson.hospital_account_record;
  } else {
    accessionNumber =
      'Accession: ' + activeCaseJson.primary_clinical_identifier.number;
    accessionIssuer =
      '(' + activeCaseJson.primary_clinical_identifier.issuer + ')';
  }

  const header = (
    <div className="case-json-header cols">
      <div className="col-7">
        <h5>
          {accessionNumber}
          {accessionIssuer}
        </h5>
      </div>
      <div className="col-5 display-controls">
        showing{' '}
        <a
          href="#/toggle"
          className={'qa-toggle-order'}
          onClick={handleToggleOrder}>
          {!isAlphaSort ? 'original' : 'A-Z'}
        </a>{' '}
        {'  '}
        <a
          href="#/toggle"
          data-testid="qa-toggle-all"
          className={'qa-toggle-all'}
          onClick={handleToggleAll}>
          {!displayInfo.collapsed ? 'expanded' : 'summary'}
        </a>
        <div>
          <ProcessSelection
            caseRuns={sortedCaseRuns}
            activeId={activeCaseJson.process_instance_id}
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div data-testid="case-json-view" className="case-json-view">
      <FlexCard header={header} className={'case-json-card'}>
        <div>{json}</div>
      </FlexCard>
    </div>
  );
};

export { CaseJson };
